import { render, staticRenderFns } from "./ViewReviewList.vue?vue&type=template&id=37e9da8e&scoped=true"
import script from "./ViewReviewList.vue?vue&type=script&lang=js"
export * from "./ViewReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9da8e",
  null
  
)

export default component.exports